import * as firebase from "firebase/app";
import { IRemoteFile } from "shared/model/IRemoteFile";
import { StorageFolders } from "shared/storage";

import Utils from "../../utils/Utils";

export default class FirebaseStorageService {
  public static async uploadCoworkReceipt(
    file: File,
    id: string = Utils.guid()
  ): Promise<IRemoteFile> {
    const path = `${StorageFolders.CoworkReceipts}/${id}.pdf`;
    return FirebaseStorageService.uploadFile(file, path);
  }

  public static async uploadContractFile(
    file: File,
    id: string = Utils.guid()
  ): Promise<IRemoteFile> {
    const path = `${StorageFolders.MemberAgreements}/${id}.pdf`;
    return FirebaseStorageService.uploadFile(file, path);
  }

  public static async uploadBankStatement(
    file: File,
    id: string = Utils.guid()
  ): Promise<IRemoteFile> {
    const path = `${StorageFolders.FinancialStatements}/${id}.pdf`;
    return FirebaseStorageService.uploadFile(file, path);
  }

  public static async uploadPhotoId(
    file: File,
    id: string = Utils.guid()
  ): Promise<IRemoteFile> {
    const ext = this.imageFileExtension(file);
    const path = `${StorageFolders.PhotoIds}/${id}.${ext}`;
    return FirebaseStorageService.uploadFile(file, path);
  }

  public static async uploadBranchBackgroundImage(
    file: File,
    id: string = Utils.guid()
  ): Promise<IRemoteFile> {
    const ext = this.imageFileExtension(file);
    const path = `${StorageFolders.BranchImages}/${id}.${ext}`;
    return FirebaseStorageService.uploadFile(file, path);
  }

  public static async uploadAvatar(
    file: File,
    id: string = Utils.guid()
  ): Promise<IRemoteFile> {
    const ext = this.imageFileExtension(file);
    const path = `${StorageFolders.Avatars}/${id}.${ext}`;
    return FirebaseStorageService.uploadFile(file, path);
  }

  public static imageFileExtension(file: File) {
    if (file.type.includes("png")) {
      return ".png";
    } else if (file.type.includes("jpg")) {
      return ".jpg";
    } else if (file.type.includes("jpeg")) {
      return ".jpg";
    } else {
      return file.name.split(".").pop();
    }
  }

  public static getDownloadUrl(path: string) {
    return firebase
      .storage()
      .ref(path)
      .getDownloadURL();
  }

  public static async uploadFile(
    file: File,
    path: string
  ): Promise<IRemoteFile> {
    const storageRef = firebase.storage().ref();
    const fileRef = storageRef.child(path);

    const data = await fileRef.put(file);
    const downloadUrl = await data.ref.getDownloadURL();
    const remoteFile: IRemoteFile = {
      downloadURL: downloadUrl!,
      fullPath: data.metadata.fullPath!,
      bucket: data.metadata.bucket!,
      originalFileName: file.name
    };

    return remoteFile;
  }
}



// WEBPACK FOOTER //
// ./src/services/firebase/storage/FirebaseStorageService.ts